import { render, staticRenderFns } from "./Lab.vue?vue&type=template&id=ee3c0aa8"
import script from "./Lab.vue?vue&type=script&lang=js"
export * from "./Lab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports